import type { SecurityContext } from "@gss/types/SecurityContext";
import { DAO } from "../DAO";
import type {
    FilterSerie,
    FilterSeriesDimensionScore,
    FilterSeriesStat,
} from "../filters/filters.types";

export async function getScoreSeries(
    audience: SecurityContext,
    filterSeries: FilterSerie[],
): Promise<{ ok: FilterSeriesDimensionScore[]; notOk: FilterSeriesStat[] }> {
    const scores = await Promise.all(
        filterSeries
            .map((fs) => {
                return DAO.stats.getDimensionScore(
                    audience,
                    fs.measurement,
                    fs.orgStructure,
                    fs.periods,
                    fs.filters,
                    fs.orgIds,
                );
            })
            .map((p) => p.catch(() => undefined)),
    );

    const ok: FilterSeriesDimensionScore[] = [];
    const notOk: FilterSeriesStat[] = [];

    for (const [i, ds] of scores.entries()) {
        if (ds != null) {
            if (ds.status === "ok") {
                ok.push({
                    filterSerie: filterSeries[i],
                    stat: ds,
                });
            } else {
                notOk.push({
                    filterSerie: filterSeries[i],
                    stat: ds,
                });
            }
        } else {
            notOk.push({
                filterSerie: filterSeries[i],
            });
        }
    }

    return { ok, notOk };
}
